import { render } from "./login-bg.vue?vue&type=template&id=0ce86253&scoped=true"
import script from "./login-bg.vue?vue&type=script&lang=js"
export * from "./login-bg.vue?vue&type=script&lang=js"

import "./login-bg.vue?vue&type=style&index=0&id=0ce86253&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce86253"]])

export default __exports__